module.exports = __webpack_public_path__ + "img/moneyWebmasterAccrued.c57876fd.svg";